export const headersOrdemCompra = [
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 6, key: 'statusCotacao' },
  { text: 'Nº REQ', width: 5, key: 'numeracaoReq' },
  { text: 'Nº Ordem', width: 5, key: 'numeracaoOrdem' },
  { text: 'Produto Farmacêutico', width: 15, key: 'produtoDAF' },
  { text: 'Qtd Encomendada', width: 7, key: 'qtdCotada' },
  { text: 'Valor Total R$', width: 10, key: 'valorTotal' },
];

export const fiscalData = [
  {
    offCanvas: '',
    fiscalId: 1,
    status: 'Ativo',
    tipoFiscal: 'Técnico',
    dataInicio: '01/01/2024',
    dataFim: '31/12/2024',
    nomeFiscal: 'Maria Souza da Silva',
  },
  {
    offCanvas: '',
    fiscalId: 2,
    status: 'Inativo',
    tipoFiscal: 'Administrativo',
    dataInicio: '15/02/2023',
    dataFim: '15/02/2024',
    nomeFiscal: 'João Carlos Ferreira',
  },
  {
    offCanvas: '',
    fiscalId: 3,
    status: 'Ativo',
    tipoFiscal: 'Técnico',
    dataInicio: '10/03/2024',
    dataFim: '10/09/2024',
    nomeFiscal: 'Ana Paula Menezes',
  },
];

export const valoresExibidosFiscalContrato: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Data de Registro',
  dataAtualizacao: 'Última Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  dataUltimaAtualizacao: 'Última Atualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  usuarioRegistro: 'Responsável pelo Registro',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  observacoes: 'Observações',

  // Fase
  status: 'Status',
  fiscal: 'Fiscal',
  tipoFiscal: 'Tipo de Fiscal',
  dataInicio: 'Data de Início',
  dataTermino: 'Data de Término',
  documentoSei: 'Documento SEI',
  link: 'Link',
  numeracaoOrdem: 'Nº Ordem de Compra',
  embalagemFator: 'Fator Embalagem',
  qtdEncomendada: 'Qtd Encomendada',
  dataOrdem: 'Data Ordem',
  dataPrevisao: 'Data Previsão',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorFiscal: '',
};

export const fieldObjectProaq = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
  'responsavel.nomeCompleto',
  'proaq.id',
  'proaqResponsavel.responsavel',
  'produtoDAF.produtoFarmaceutico',
  'denominacaoGenerica.denominacaoGenerica',
  'KitProdutoDAF.nomeKit',
];
